import { RECEIVE_ISSUES, REQUEST_ISSUES } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_ISSUES:
            return { ...state, isFetching: true, shouldFetch: false, ...data }

        case RECEIVE_ISSUES:
            return { ...state, isFetching: false, ...data }

        default:
            return state
    }
}
